// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateLaborAdditiveSummaryModalVisibility = (state, action) => action.isVisible;

export default (state = getDefaultState().isVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARY_MODAL_VISIBILITY]: updateLaborAdditiveSummaryModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/labor-additive/reducers/labor-additive-summary-modal-visibility.js